{
  "title": "Settings",
  "logout": "Sign out",
  "logout_failed": "Sign out failed. Please try again.",
  "restore_purchases": "Restore purchases",
  "restore_purchases_hint": "Reinstalled the app or changed device?",
  "restore_purchases_mismatch_title": "Subscription linked to another account",
  "restore_purchases_mismatch_message": "This purchase belongs to another account. Sign in with the original account used for this subscription and try again.",
  "manage_subscription": "Manage Subscription",
  "subscribe": "Start subscribing",
  "subscription_ends_in_days_one": "Ends in {{count}} day",
  "subscription_ends_in_days_other": "Ends in {{count}} days",
  "subscription_ends_in_hours_one": "Ends in {{count}} hour",
  "subscription_ends_in_hours_other": "Ends in {{count}} hours",
  "subscription_ends_in_minutes_one": "Ends in {{count}} minute",
  "subscription_ends_in_minutes_other": "Ends in {{count}} minutes",
  "subscription_ends_soon": "Ends soon",
  "language": "Language",
  "language_en": "English",
  "language_sv": "Swedish",
  "change_language": "Change Language",
  "restored_success": "Purchases restored successfully.",
  "restore_purchases_failed": "Failed to restore purchases.",
  "no_subscriptions_title": "No Subscriptions",
  "no_subscriptions_message": "Can not manage subscription. Please email support@vocalise.app for help.",
  "subscription_link_hint_ios": "Opens in App Store",
  "subscription_link_hint_android": "Opens in Google Play",
  "subscription_link_hint_web": "Opens in browser",
  "end_subscription_failed": "Failed to open subscription management. Please try again.",
  "anonymous_user": "User",
  "version_label": "Version",
  "version_accessibility_label": "Version {{version}}",
  "developer_mode_label": "Developer mode",
  "developer_mode_enabled_title": "Developer mode enabled",
  "developer_mode_enabled_message": "The voice assessment prompt will always be shown.",
  "developer_mode_disabled_title": "Developer mode disabled",
  "developer_mode_disabled_message": "The voice assessment prompt will follow its normal schedule.",
  "developer_mode_update_failed": "Developer mode could not be updated. Please try again.",
  "remove_account": "Remove Account",
  "remove_account_confirm_title": "Remove Account?",
  "remove_account_confirm_message": "This will permanently delete your account and all associated data. This action cannot be undone.",
  "remove_account_final_confirm": "Yes, Remove My Account",
  "remove_account_success": "Your account has been removed.",
  "remove_account_failed": "Failed to remove account. Please try again.",
  "remove_account_blocked_title": "Active Subscription",
  "remove_account_blocked_message": "You must cancel your subscription before removing your account. Please unsubscribe using the link below, then come back and try again.",
  "remove_account_unsubscribe_ios": "Manage Subscriptions in App Store",
  "remove_account_unsubscribe_web": "Manage Subscription",
  "remove_account_unsubscribe_android": "Manage Subscriptions in Google Play",
  "remove_account_unsubscribe_hint_ios": "Opens in App Store",
  "remove_account_unsubscribe_hint_web": "Opens in browser",
  "remove_account_unsubscribe_hint_android": "Opens in Google Play",
  "remove_account_refresh_status": "I've Cancelled — Check Again",
  "email_not_verified_title": "Email not verified",
  "email_not_verified_message": "Please verify your email address to secure your account.",
  "resend_verification_email": "Resend verification email",
  "waiting_for_verification": "Waiting for verification...",
  "resend_verification_success_title": "Verification email sent",
  "resend_verification_success_message": "Check your inbox at {{email}}.",
  "resend_verification_failed": "Failed to send verification email. Please try again.",
  "edit_name": "Edit name",
  "edit_name_description": "This is how your name appears in the app.",
  "edit_name_placeholder": "Enter your name",
  "edit_name_empty_error": "Name cannot be empty.",
  "edit_name_success": "Your name has been updated.",
  "edit_name_failed": "Failed to update name. Please try again.",
  "report_issue_settings_label": "Report an issue",
  "report_issue_settings_hint": "Send diagnostics",
  "report_issue_heading": "Tell us what happened",
  "report_issue_description": "Describe the issue and what you were trying to do. We will include app, device, route, and connection details so the report is easier to investigate.",
  "report_issue_linked_event_title": "Linked to an error report",
  "report_issue_linked_event_message": "Your feedback will be attached to reference {{eventId}}.",
  "report_issue_message_label": "What went wrong?",
  "report_issue_message_placeholder": "Describe what happened and what you were trying to do.",
  "report_issue_name_label": "Name (optional)",
  "report_issue_name_placeholder": "Your name",
  "report_issue_email_label": "Email (optional)",
  "report_issue_email_placeholder": "you@example.com",
  "report_issue_message_min_length": "Please add at least {{count}} characters.",
  "report_issue_sentry_disabled": "Issue reports are only sent from builds with diagnostics enabled.",
  "report_issue_submit_failed": "Failed to send your report. Please try again.",
  "report_issue_submit": "Send report",
  "report_issue_success_title": "Report sent",
  "report_issue_success_message": "Thanks. We received your report and diagnostics.",
  "test_store_title": "Test Store - simulated purchases",
  "test_store_message": "Can not manage subscription in test store. Please email support@vocalise.app for help.",
  "can_not_manage_subscription": "Can not manage subscription. Please email support@vocalise.app for help."
}
